import PropTypes from 'prop-types';
import { useMemo, useContext } from 'react';
// material
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import shape from './shape';
import palette from './palette';
import typography from './typography';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';
// context
import { SettingsContext } from '../contexts/Settings';

// ----------------------------------------------------------------------

ThemeConfig.propTypes = {
  children: PropTypes.node
};

export default function ThemeConfig({ children }) {
  const { themeSettings } = useContext(SettingsContext);

  const themeOptions = useMemo(
    () => ({
      palette: {
        ...palette,
        ...themeSettings.palette,
        gradients: {
          ...palette.gradients,
          ...themeSettings.palette.gradients
        }
      },
      shape,
      typography,
      shadows,
      customShadows: {
        ...customShadows,
        ...themeSettings.customShadows
      }
    }),
    [themeSettings]
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
